import { getKyClient } from './client';

export const putTcAccepted = async (tcAccepted) => {
  const url = `v1.0/TermsAndConditions/${tcAccepted}`;
  const kyClient = await getKyClient();
  return kyClient.put(url);
};
